import { getDemoPreviews } from './get-demo-previews';
import { shouldShowField } from './should-show-field';
import { validateForm } from './validate-form';
import { applyFieldLogic } from './apply-field-logic';
import { getDynamicOptions } from './get-dynamic-options';
import { getMaxLinesForVariant } from './get-max-lines';
import { getFileNaming } from './get-filenaming';

export const getMacroSacaTuTarjetaHelpers = () => ({
  shouldShowField,
  validateForm,
  getDemoPreviews,
  applyFieldLogic,
  getDynamicOptions,
  getMaxLinesForVariant,
  getFileNaming
});

export {
  shouldShowField,
  validateForm,
  getDemoPreviews,
  applyFieldLogic,
  getDynamicOptions,
  getMaxLinesForVariant,
  getFileNaming
};
